export default "__VITE_ASSET__lC6H2H83__"